import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import ProspectMappingModal from './ProspectMappingModal';
import RouteConstants from '../../../common/RouteConstants';

// Standalone route wrapper so the prospect-mapping experience is reachable both
// as a modal from the Evaluation Search page and via its own dedicated route.
const ProspectMappingPage = () => {
  const history = useHistory();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    history.push(RouteConstants.ADMIN_EVALUATION_SEARCH);
  };

  return <ProspectMappingModal open={open} onClose={handleClose} />;
};

export default ProspectMappingPage;
